import { escapeAttr, escapeHtml, linkAttrs } from "@emkit/builder-core";
export const GALLERY_DEFAULTS = {
    images: [
        {
            id: "g1",
            src: "https://placehold.co/600x600/e5e7eb/6b7280?text=1",
            alt: "Placeholder 1",
        },
        {
            id: "g2",
            src: "https://placehold.co/600x600/e5e7eb/6b7280?text=2",
            alt: "Placeholder 2",
        },
        {
            id: "g3",
            src: "https://placehold.co/600x600/e5e7eb/6b7280?text=3",
            alt: "Placeholder 3",
        },
        {
            id: "g4",
            src: "https://placehold.co/600x600/e5e7eb/6b7280?text=4",
            alt: "Placeholder 4",
        },
        {
            id: "g5",
            src: "https://placehold.co/600x600/e5e7eb/6b7280?text=5",
            alt: "Placeholder 5",
        },
        {
            id: "g6",
            src: "https://placehold.co/600x600/e5e7eb/6b7280?text=6",
            alt: "Placeholder 6",
        },
    ],
    columns: 3,
    gap: 12,
    radius: 8,
    fit: "cover",
    square: true,
};
export const galleryWidget = {
    type: "gallery",
    defaultProps: GALLERY_DEFAULTS,
    renderHtml(props, ctx) {
        const images = props.images ?? [];
        if (images.length === 0) {
            return `<div class="emk-gallery" style="padding:12px;color:#9ca3af;font-size:13px;text-align:center;border:1px dashed #e5e7eb;border-radius:6px">(Empty gallery — add images in the inspector)</div>`;
        }
        const cols = props.columns ?? 3;
        const gap = props.gap ?? 12;
        const radius = props.radius ?? 8;
        const fit = props.fit ?? "cover";
        const square = props.square ?? true;
        // Responsive grid: use CSS min() so the tile never gets absurdly narrow
        // on phones. Tablets and below halve columns, never below 1 (2 if ≥4 imgs).
        const gridStyle = [
            "display:grid",
            `grid-template-columns:repeat(${cols},minmax(0,1fr))`,
            `gap:${gap}px`,
            "font-family:inherit",
        ].join(";");
        const tileStyle = [
            "display:block",
            "position:relative",
            square ? "aspect-ratio:1/1" : "",
            "overflow:hidden",
            `border-radius:${radius}px`,
            "background:#f3f4f6",
        ]
            .filter(Boolean)
            .join(";");
        const imgStyle = [
            "display:block",
            "width:100%",
            "height:100%",
            square ? `object-fit:${fit}` : "width:100%;height:auto;object-fit:initial",
        ].join(";");
        const tiles = images
            .map((img) => {
            const url = ctx.resolveAssetUrl ? ctx.resolveAssetUrl(img.src) : img.src;
            const inner = `<img src="${escapeAttr(url)}" alt="${escapeAttr(img.alt)}" loading="lazy" decoding="async" style="${imgStyle}">`;
            const caption = img.caption
                ? `<figcaption style="margin-top:6px;font-size:13px;color:#6b7280;line-height:1.4;text-align:center">${escapeHtml(img.caption)}</figcaption>`
                : "";
            const tile = img.href
                ? `<a href="${escapeAttr(img.href)}"${linkAttrs(img.href)} class="emk-gallery-tile" style="${tileStyle};text-decoration:none">${inner}</a>`
                : `<div class="emk-gallery-tile" style="${tileStyle}">${inner}</div>`;
            return caption ? `<figure style="margin:0">${tile}${caption}</figure>` : tile;
        })
            .join("");
        return `<div class="emk-gallery" style="${gridStyle}">${tiles}</div>`;
    },
};
//# sourceMappingURL=gallery.js.map